<template>
  <div id="app" @click="isDo()">
    <!-- 只留下主內容定位點 -->
    <a
      accesskey="C"
      href="#mainContent"
      title="跳到主要內容區"
      class="sr-only sr-only-focusable"
      tabindex="0"
      >跳到主要內容區</a
    >

    <!-- Header -->
    <header class="no-print">
      <font-awesome-icon
        v-if="btnFlag"
        class="go-top app-img no-print"
        @click="backTop"
        icon="angle-double-up"
        size="3x"
      />
    </header>

    <!-- 主要內容本體 -->
    <main class="sView">
      <app-webAlert />
      <ModalAlert />
      <Loading />
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="sFooter no-print">
      <app-footer />
    </footer>
  </div>
</template>

<script>
import webAlert from './components/Features/webAlert'
import ModalAlert from './components/Features/ModalAlert'
import Footer from './components/Layout/Footer.vue'
import Loading from './components/Features/Loading'

export default {
  name: 'App',
  components: {
    Loading,
    'app-footer': Footer,
    ModalAlert,
    'app-webAlert': webAlert
  },
  data () {
    return {
      btnFlag: '',
      lastTime: null, // 最後一次點擊時間
      currentTime: null, // 目前點擊時間
      timeOut: 30 * 60 * 1000 // 設定閒置時間： 30分鐘
    }
  },
  created () {
    localStorage.setItem('host', window.location.host)
    this.lastTime = new Date().getTime() // 紀錄當前時間
  },
  // window對象，監聽滾動事件
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
    // IE轉換頁面修正功能
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      window.addEventListener(
        'hashchange',
        () => {
          let currentPath = window.location.hash.slice(1)
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        },
        false
      )
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 點擊圖片回到頂部
    backTop () {
      let that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    // 計算距離頂部的高度，當高度大於60顯示回頂部圖標，小於60則隱藏
    scrollToTop () {
      let that = this
      let scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 0) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    isDo () {
      let vm = this
      // 記錄這次點擊的時間
      vm.currentTime = new Date().getTime()
      // 判斷上次最後一次點擊的時間和這次點擊的時間間隔是否大於3分鐘
      if (vm.currentTime - vm.lastTime > vm.timeOut) {
        vm.$bus.$emit('LogOutCheckUser', 'null')
        vm.lastTime = new Date().getTime()
      } else {
        // 如果在3分鐘內點擊，則把這次點擊的時間記錄覆蓋掉之前存的最後一次點擊的時間
        vm.lastTime = new Date().getTime()
      }
    }
  }
}
</script>

<style lang="scss">
@import './assets/All.scss';
@import './assets/components.scss';
.sFooter {
  height: 125px;
}
.sView {
  min-height: calc(100vh - 70px);
}

#app {
  //水平置中對齊
  text-align: center;
  //背景底色
  background-color: #6c5aff17;
}
// 回到頂部
.app-img {
  display: block;
  right: 3%;
  position: fixed;
  top: 70%;
  float: right;
  z-index: 999;
  color: #0000007a;
}

.sr-only {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: fixed !important;
  top: 1rem;
  left: 1rem !important;
  width: auto !important;
  height: auto !important;
  padding: 0.5rem 1.75rem;
  background: #1565c0; /* 醒目藍色背景 */
  border: none;
  color: #fff; /* 白色字 */
  font-size: 1rem;
  font-weight: 600; /* 加粗字體 */
  border-radius: 0.375rem;
  box-shadow: 0 4px 8px rgba(21, 101, 192, 0.6); /* 陰影 */
  text-decoration: none;
  z-index: 10001;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  outline: none;
}

.sr-only-focusable:focus {
  box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.8); /* 明顯的聚焦外框 */
  background-color: #0d47a1; /* 聚焦時加深藍色 */
  color: #fff;
}

.sr-only-focusable:hover {
  background-color: #1976d2; /* 滑鼠懸停顏色稍微亮一點 */
  color: #e3f2fd;
  border-color: transparent;
  box-shadow: 0 4px 10px rgba(25, 118, 210, 0.7);
}
</style>
